<template>
    <select :id="selectId"
            class="go-vendor"
            v-bind:class="getClass"
            @change="callSetSelectedValue">
        <option v-if="getPlaceHolder !== null" value="">{{$te(getPlaceHolder) ? $t(getPlaceHolder) : getPlaceHolder}}</option>
        <option
            v-for="option in getOptions"
            v-bind:value="option[selectValue]"
            :data-icon="option.dataIcon !== 'undefined' ? option.dataIcon : null "
            :key="option[selectValue]">
            {{ getOptionText(option) }}
        </option>
    </select>
</template>

<script>

    import { EventBus } from "./event-bus";

    export default {
        name: "SelectBoxSingle",
        data() {
            return {
                value: ""
            }
        },
        props: {
            callSetSelectedValue: {
                type: Function,
                default: ()=>{}
            },
            selectId: String,                   // 셀렉트 박스 ID(SPA 페이지에서 로딩된 DOM 중 유일한 값으로 지정할 것)
            selectBoxValue: String | Number,    // 초기 값 리스트
            selectBoxOptions: {
                type: Array | Object,   // Option 정보 리스트 (일반 Array, 동적 바인딩 구현 시 각 Key값을 가지고 있는 배열을 포함한 Object로 Bind)
                default: ()=>{return []}
            },
            selectClass: String,                // Select tag 사용자 정의 Class
            placeHolder: String,                // PlaceHolder value
            beforeText: {
                type :String,
                default: ''
            },                                  // Text value 앞에 추가될 문구(다국어 용)
            selectValue: {
                type: String,
                default: 'key'
            },                                  // Options key 값이 될  Attribute name
            selectText: {
                type: String,
                default: 'val'
            },                                  // Options text 표시값이 될  Attribute name
            dataInvalid: {
                type: Boolean | String,
                default: false
            },                                  // Validation Check flag
            disabled: {
                type: Boolean | String,
                default: false
            },                                  // Disabled flag
            useTranslate: {
                type: Boolean | String,
                default: false
            },                                  // i18n Translate 플래그
            useDynamic: {
                type : Boolean | String,
                default : false
            },
            dynamicValue: Number | String       // 동적 바인딩 사용 플래그
        },
        computed:{
            getClass:function(){
                let sClass = typeof(this.selectClass) !== 'undefined'
                     ? this.selectClass + ' ' + this.selectId
                     : this.selectId

                sClass = this.disabled ? sClass + ' ' + 'disabled' : sClass
                return sClass
            },
            getPlaceHolder: function() {
                return typeof(this.placeHolder) !== 'undefined' ? this.placeHolder : null
            },
            getUseTranslate: function() {
                return typeof(this.useTranslate) !== 'undefined' ? this.useTranslate : false
            },
            getDVal: function() {
                return typeof(this.dynamicValue) !== 'undefined' ? this.dynamicValue : ''
            },
            getOptions: function() {
                let options = [];
                if (this.useDynamic === true) {
                    if (typeof(this.selectBoxOptions[this.getDVal]) !== 'undefined') {
                        options = this.selectBoxOptions[this.getDVal];
                    }
                } else {
                    options = this.selectBoxOptions;
                }
                return options;
            }
        },
        mounted() {

            this.value = !this.selectBoxValue ? this.selectBoxValue : ""
            if(!this.selectBoxOptions){
                this.selectBoxOptions = [];
            }

            EventBus.$on("changeLocale", e => {
                //$(`#${this.selectId}`).dropdown('clear')

            });

            this.initSelectBox()
            //$(this.$el).dropdown();
        },
        destroyed: function() {
        },
        watch: {
            dataInvalid: function(){
                this.dataInvalid ? $(`.go-vendor.${this.selectId}.ui.dropdown`).attr("data-invalid", true) : $(`.go-vendor.${this.selectId}.ui.dropdown`).removeAttr("data-invalid")
            },
            selectBoxValue: function(){
                if(typeof(this.selectBoxValue) !== 'undefined') {
                    $(`#${this.selectId}`).dropdown('set exactly', this.selectBoxValue)
                }
            },
            dynamicValue: function(){
                setTimeout(function() {
                    $(`#${this.selectId}`).dropdown('restore defaults')
                }, 100);

            }
        },
        methods: {
            getOptionText(option) {
                const {beforeText, selectText, getUseTranslate} = this;
                let optTxt = option[selectText];
                if (optTxt && optTxt.includes("microsoft")) {
                    const re = /microsoft/gi;
                    optTxt = optTxt.replace(re, "Microsoft");
                }

                let text = beforeText + optTxt;
                if (getUseTranslate && this.$te(beforeText + optTxt)) {
                    text = this.$t(beforeText + optTxt);
                }
                return text;
            },
            initSelectBox: function() {
                let self = this

                $(`#${this.selectId}`).dropdown({
                    onChange: function(value, text, $choice) {
                        self.value = value
                        self.$emit('onSelectChange', {'id': self.selectId, 'value': value});
                    }
                });

                if(typeof(this.selectBoxValue) !== 'undefined'){
                    $(`#${this.selectId}`).dropdown('set exactly', this.selectBoxValue)

                }
                this.dataInvalid ? $(`.go-vendor.${this.selectId}.ui.dropdown`).attr("data-invalid", true) : $(`.go-vendor.${this.selectId}.ui.dropdown`).removeAttr("data-invalid")
            },
            updateDropdown() {
                let id_value = $(this.$el).find('input').val();
                id_value = (id_value === "" || id_value == null) ? '' : id_value;
                this.$emit('onSelectChange', {'id': self.selectId, 'value': id_value});
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/selectBoxSingle.vue